import {
  AlertCircleIcon,
  File02Icon,
  Rotate02Icon,
  UnavailableIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Show } from "shared/components";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { cx } from "shared/utils";
import { DocumentProblem } from "../utils/documentProblems";

const resolveCellState = (
  problems: DocumentProblem[],
  isProcessing: boolean
) => {
  if (isProcessing)
    return {
      HugeIcon: Rotate02Icon,
      label: "Checking the file",
      className: "text-warning-700"
    };

  if (problems.length === 0)
    return { HugeIcon: File02Icon, label: null, className: "text-content-200" };

  const label =
    problems.length > 1 ? "Issues in the document" : problems[0].label;

  return {
    HugeIcon: label === "Rejected" ? UnavailableIcon : AlertCircleIcon,
    label,
    className: "text-danger-500"
  };
};

export const DocumentCell = ({
  filename,
  problems,
  isProcessing = false
}: {
  filename: string;
  problems: DocumentProblem[];
  isProcessing?: boolean;
}) => {
  const state = resolveCellState(problems, isProcessing);

  return (
    <div className="flex items-center gap-3">
      <HugeiconsIcon
        icon={state.HugeIcon}
        size={20}
        strokeWidth={1.5}
        className={cx("shrink-0", state.className)}
      />

      <div className="flex flex-col items-start">
        <Tooltip>
          <TooltipTrigger>
            <p className="max-w-[140px] overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium text-content-1000">
              {filename}
            </p>
          </TooltipTrigger>
          <TooltipContent className="z-[50] max-w-[370px] rounded-lg border bg-alpha-800 p-4 text-sm text-content-1000-inverted">
            {filename}
          </TooltipContent>
        </Tooltip>

        <Show if={Boolean(state.label)}>
          <p className={cx("text-sm font-normal", state.className)}>
            {state.label}
          </p>
        </Show>
      </div>
    </div>
  );
};
